import {Injectable} from '@angular/core';
import {HttpClientService} from './httpClient.service';
import {Usuario} from '../model/usuario.model';
import {Cookie} from '../model/cookie.model';
import {of} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {ConfigurationService} from './configuration.service';

@Injectable()
export class UsuarioService {

    private httpOptions: any; // {  "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}` };
    private apiUrl: string;
    private vipList: Array<string> = null;

    constructor(
        private http: HttpClientService,
        private configService: ConfigurationService
        ) {
            this.onConfigLoad = this.onConfigLoad.bind( this );
            configService.loadConfigurations().subscribe( this.onConfigLoad );
        }

        auth(model){
            return this.http.post(`${this.apiUrl}/oauth/token`, {
              'agencyId': model.agencyId,
              'login': model.login,
              'senha': model.senha,
              'token': model.token
            }, {'Content-Type': 'application/json'}).pipe(
                switchMap((responseToken: any) => {
                    localStorage.setItem('authToken', responseToken.access_token);
                    return of(responseToken);
                })
            );
        }

        efetuarLogin(model, authResult) {
      let options = {
                'Content-Type': 'application/json',
                "Tenant": `${model.agencyId}`,
                "Authorization": `Bearer ${authResult.access_token}`
            };
            return this.http.post<Usuario>(`${this.apiUrl}/back/usuario/login`, model, options).pipe(map(response => response));
        }

        editCadastro(model){
            return this.http.put<Usuario>(`${this.apiUrl}/back/usuario`, model, { 'Content-Type': 'application/json' }).pipe(map(response => response));
        }

        postCadastro(model){
            return this.http.post<Usuario>(`${this.apiUrl}/back/usuario`, model, { 'Content-Type': 'application/json' }).pipe(map(response => response));
        }

        getToken(agencyId) {
            this.getAuthToken();
            return this.http.post<Cookie>(`${this.apiUrl}/back/integracao/login?agencyId=${agencyId}`, '', this.httpOptions).pipe(map(response => response)).pipe(map(response => response));
        }

        getDadosUsuario() {
            return JSON.parse(localStorage.getItem('usuario'));
        }

        getUsuario(documento) {
            const cookie = JSON.parse(localStorage.getItem('cookie'));
            return this.http.get<Usuario>(`${this.apiUrl}/back/integracao/usuario?cookie=` + cookie + '&documento=' + documento).pipe(map(response => response));
        }

        validateCaptcha(token, agencyId: Number) {
            let options = {
                'Referer': agencyId
            };

            return this.http.get<any>(`${this.apiUrl}/back/usuario/validate-captcha?token=` + token + "&tenant=" + agencyId, options).pipe(map(response => response));
        }

        postEsqueciSenha(model){
            return this.http.post<Usuario>(`${this.apiUrl}/back/usuario/esqueci`, model, { 'Content-Type': 'application/json' }).pipe(map(response => response));
        }

        postNovaSenha(token, senha){
            return this.http.post<Usuario>(`${this.apiUrl}/back/usuario/novaSenha?token=` + token, senha, { 'Content-Type': 'text/plain' }).pipe(map(response => response));
        }

        getPartialPhone(model) {
            return this.http.post<Usuario>(`${this.apiUrl}/back/usuario/partialPhone`, model, { 'Content-Type': 'application/json' }).pipe(map(response => response));
        }

        sendSms(model) {
            return this.http.post<any>(`${this.apiUrl}/back/usuario/sendSms`, model, { 'Content-Type': 'application/json' }).pipe(map(response => response));
        }

        validToken(token) {
            return this.http.get<{valid: boolean, confirmed: boolean, askPassword: boolean}>(`${this.apiUrl}/back/usuario/token/${token}`).pipe(map(response => response));
        }

        private onConfigLoad( config ) {
            this.apiUrl = config.apiUrl;

            if ( config.features ) {
                this.vipList = config.features.vipList;
            }
        }

        private getAuthToken(){
            this.httpOptions = {  'Content-Type': 'application/x-www-form-urlencoded', "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}` };
        }
    }
